<template lang="pug">
    layout

        // Title
        title-component(
            :title="$t('profile.navigation[0].title')"
            slot="title"
            type="h2"
        )

        v-layout(raw wrap)
            v-flex(xs12)

                // Profile information
                profile-information

            v-flex(xs12 v-if="isChampion")
                // Only visible for Champion

                // Horizontal line
                separator-component

                div.padderRight.mb-3.mt-4
                    div {{ $t('profile.businessDataParameters.activeSince') }}
                        strong {{ user.createdAt | formattedDate }}
                    div(v-html="$t('profile.businessDataParameters.currentMaxCapacity', { capacity: user.business.maxUsers })")


            v-flex(xs12 v-if="isInstructor")

                // Personal information
                personal-form.mt-2(ref="personalForm")

            v-flex(xs12 v-if="isInstructor")
                cover-photo

            v-flex(xs12 v-if="isInstructor")
                // Horizontal line
                separator-component

                div.controls

                    div
                        // Submit button
                        button-component.mr-0.submit(
                            color="primary"
                            :action="submit"
                            :isLoading="isLoading"
                            large
                        ) {{ $t('defaultButtons.save') }}
</template>

<script>
    import Layout from '../Layout';
    import ProfileInformation from './ProfileInformation.vue';
    import PersonalInformationForm from './PersonalInformationForm';
    import CoverPhoto from './CoverPhoto';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapGetters } from 'vuex';
    import formattedDate from '~filters/FormattedDate';

    export default {
        components: {
            Layout,
            ProfileInformation,
            CoverPhoto,
            PersonalForm: PersonalInformationForm,
            TitleComponent: Title,
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        filters: {
            formattedDate
        },
        computed: {
            ...mapGetters('auth', [
                'user',
                'isInstructor',
                'isLoading',
                'isChampion'
            ])
        },
        methods: {
            /**
             * Update password
             */
            async submit() {
                if (this.isInstructor) {
                    const resp = await this.$refs.personalForm.submitForm();
                    if (!resp) return;
                }
            }
        }
    };
</script>

<style lang="stylus" scoped></style>
